export default "__VITE_ASSET__CcMlQhGc__"